import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=52e8d0fc&scoped=true"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=52e8d0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8d0fc",
  null
  
)

export default component.exports